import * as Sentry from '@sentry/react';
import { useParams } from 'react-router-dom';
import { Group, LoadingOverlay, Stack, ThemeIcon, Title, Tooltip } from 'ui';
import { IconInfoCircle } from 'ui/Icons';

import { StudentPaymentsList } from '../components/organisms/lists/StudentPaymentList/StudentPaymentList';

const ListStudentPaymentsGuard = () => {
  const { studentId } = useParams();

  if (!studentId) {
    return <LoadingOverlay visible />;
  }
  return <StudentPaymentsList studentId={studentId} />;
};

const Payments = () => {
  return (
    <Sentry.ErrorBoundary fallback={<p>There was an error loading your payments</p>}>
      <Stack>
        <Group justify="space-between">
          <Title order={2}>Payments</Title>
          <Tooltip label="If you've made partial payments, the total amount paid toward this fee will appear here.">
            <ThemeIcon size="md" c="gray.6" radius="sm" variant="transparent">
              <IconInfoCircle size={16} brand="tabler" />
            </ThemeIcon>
          </Tooltip>
        </Group>
        <ListStudentPaymentsGuard />
      </Stack>
    </Sentry.ErrorBoundary>
  );
};

export { Payments };
